<template>
    <div>       
        <b-tabs fill v-model="tabIndex">
           
        </b-tabs>
    </div>
</template>

<script>


export default {
    name: 'NotaDebito',
    components: {

    },
    data: () => {
        return  {

        }
    }
}
</script>

